import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Calendar, ArrowDownCircle, ArrowUpCircle } from 'lucide-react';

interface RecurringTransactionsCardThumbnailProps {
  isHovered?: boolean;
  alwaysVisible?: boolean;
}

export function RecurringTransactionsCardThumbnail({ isHovered = false, alwaysVisible }: RecurringTransactionsCardThumbnailProps) {
  const baseScale = alwaysVisible ? 'scale-[0.4]' : 'scale-100';
  const hoverScale = isHovered ? 'scale-100' : baseScale;

  return (
    <div className={`transition-transform duration-300 origin-left ${hoverScale} ${isHovered ? 'z-50' : 'z-0'}`}>
      <Card className="w-[300px] shadow-sm">
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium flex items-center gap-2">
            Recurring Transactions
            <Calendar className="h-3 w-3" />
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-2">
          <div className="text-xs text-muted-foreground">Next 30 Days</div>
          <div className="space-y-1.5 text-xs">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-1.5">
                <ArrowDownCircle className="h-3 w-3 text-red-600" />
                <span>Office Rent</span>
              </div>
              <span className="font-semibold">£12,500</span>
            </div>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-1.5">
                <ArrowDownCircle className="h-3 w-3 text-red-600" />
                <span>Payroll</span>
              </div>
              <span className="font-semibold">£85,000</span>
            </div>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-1.5">
                <ArrowUpCircle className="h-3 w-3 text-green-600" />
                <span>Client Retainer</span>
              </div>
              <span className="font-semibold">£25,000</span>
            </div>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-1.5">
                <ArrowDownCircle className="h-3 w-3 text-red-600" />
                <span>Software Licenses</span>
              </div>
              <span className="font-semibold">£3,200</span>
            </div>
          </div>
          <div className="pt-2 border-t text-xs">
            <div className="flex justify-between font-semibold">
              <span>Net Impact</span>
              <span className="text-red-600">-£75,700</span>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
